<template lang="pug">
  .planInfoCard.infoPayment
    h2.infoPayment__title Pagamento

    .infoPayment__container
      ol.infoPayment__listValues
        li
          span.infoPayment__listValues__label.infoPayment__listValues__label--gray {{ product.name }}
          strong.infoPayment__listValues__value {{ insuranceTotalAmount | currency }}

        li.infoPayment__voucher(v-if="isActiveVoucher")
          span.infoPayment__listValues__label Voucher aplicado
          strong.infoPayment__listValues__value - {{ precoTotal | currency }}

        li(v-else-if="isPromoCode")
          span.infoPayment__listValues__label.infoPayment__listValues__label--promo {{ labelPromoCode }}
          strong.infoPayment__listValues__value.infoPayment__listValues__value--promo {{ valuePromo }}

        li.infoPayment__protectedBag(v-if="hasProtectedBagAsAdditional")
          span.infoPayment__listValues__label.infoPayment__listValues__label--gray {{ protectedBag.label }}
          strong.infoPayment__listValues__value {{ protectedBag.total | currency }}

      .infoPayment__amount(:class="{ 'infoPayment__amount--splitter' :  hasTotalAmountSplitter }")
        span.infoPayment__amount__label {{ lblAmount }}
        strong.infoPayment__amount__value(v-if="isActiveVoucher") R$ 0,00
        strong.infoPayment__amount__value(v-else-if="hasPromoFirstInstallment")
          | {{ ($options.filters.convertStringToNumber(precoTotal) - parcelasPrecos[11]) | currency }}
        strong.infoPayment__amount__value(v-else) {{ lblTotalAmount | currency }}

      .infoPayment__installments
        span.infoPayment__listValues__label {{ labelInstallment }}
        strong.infoPayment__listValues__value {{ valueInstallment | currency }}

      .partner-discount(v-if="isPartner && hasPromocodeApplied")
        .partner-discount-label
          img(class='partner-logo' :src="partnerLogos[campaign]", alt="Logo Parceiro")
          strong Desconto aplicado
          img(class='partner-check-icon' src=('../../assets/icons/check-success.svg'), alt="")

      cp-warningBox(
        v-if="warningBox.enable"
        :config="warningBox"
      )

      cp-promoCode(v-if="enablePromoCode")
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { currency, convertStringToNumber } from '@/utils/filters'
import cpSpan from '@/components/atoms/Span.vue'
import cpWarningBox from '@/components/atoms/WarningBox.vue'
import cpPromoCode from '@/components/molecules/PromoCode'

export default {
  name: 'InfoPayment',
  components: {
    cpSpan,
    cpWarningBox,
    cpPromoCode
  },
  filters: {
    currency,
    convertStringToNumber
  },
  computed: {
    ...mapState('product', [
      'aliasEN',
      'campaign',
      'recurrent',
      'infoPayment',
      'isRenovation',
      'warningBox'
    ]),
    ...mapState('plan', [
      'annualValue',
      'default',
      'parcela',
      'parcelasPrecos',
      'precoTotal',
      'preco',
      'promoCode',
      'promo',
      'somenteRoubo'
    ]),
    ...mapState('payment', ['parcels', 'isActiveVoucher', 'typePayment', 'isPromoFirstInstallment']),
    ...mapState(['product', 'urlParams']),
    ...mapGetters('payment', ['isAnnual']),
    hasPromoFirstInstallment () {
      const installment = this.parcels || this.parcela
      return !this.isRenovation &&
        this.isPromoFirstInstallment &&
        (!this.typePayment || this.typePayment.method === 'CREDIT_CARD') &&
        this.$options.filters.convertStringToNumber(installment) === 12
    },
    enablePromoCode () {
      return this.promoCode &&
        this.promoCode.enable &&
        !this.isAnnual &&
        this.typePayment.method !== 'VOUCHER'
    },
    insuranceTotalAmount () {
      const insuranceType = this.somenteRoubo ? 'theftPrice' : 'completePrice'

      if (this.isPromoCode) {
        return this.default[insuranceType]
      }

      return this.promo[insuranceType] || this.default[insuranceType]
    },
    hasProtectedBagAsAdditional () {
      return !!this.product.plan.protectedBag
    },
    protectedBag () {
      return {
        label: this.product.plan.protectedBag.bagName,
        total: this.product.plan.protectedBag.bagPrice
      }
    },
    labelInstallment () {
      if (this.hasPromoFirstInstallment) {
        return '11x sem juros + 0'
      }

      const installment = this.parcels || `Até ${this.parcela || 12}`
      return `${installment}x sem juros de`
    },
    valueInstallment () {
      const installment = (this.parcels || this.parcela || 12) - 1
      return this.parcelasPrecos && this.parcelasPrecos[installment]
    },
    lblAmount () {
      if (this.isAnnual) return 'Valor anual:'

      return this.isRecurrent ? 'Valor mensal:' : 'Valor total:'
    },
    lblTotalAmount () {
      if (this.isAnnual) return this.annualValue
      return this.precoTotal
    },
    isPromoCode () {
      return !this.campaign && this.promoCode && this.promoCode.applied
    },
    labelPromoCode () {
      return this.isPromoCode
        ? `Cupom: ${this.promoCode.code.toUpperCase()}`
        : null
    },
    valuePromo () {
      const insuranceType = this.somenteRoubo ? 'theftPrice' : 'completePrice'

      if (!this.isPromoCode || !this.default[insuranceType]) return

      if (this.promoCode.discountAmount) {
        return `- ${this.$options.filters.currency(this.promoCode.discountAmount)}`
      }

      const defaultTotal = this.$options.filters
        .convertStringToNumber(this.default[insuranceType])

      const promoTotal = this.$options.filters
        .convertStringToNumber(this.promo[insuranceType])

      const res = this.$options.filters
        .currency(defaultTotal - promoTotal)
        .replace('-', '')

      return `- ${res}`
    },
    hasTotalAmountSplitter () {
      return !this.isRecurrent || (this.isRecurrent && this.isPromoCode) || this.isActiveVoucher
    }
  },
  data () {
    return {
      isPartner: false,
      partnerLogos: {
        attrium: 'https://s3.amazonaws.com/ciclic-static.s3.amazonaws.com/logo/attrium--badge.webp',
        bbagenciascpq: 'https://ciclic.imgix.net/logos/logo-clubebb-badge.png?auto=format,compress',
        clubebb: 'https://ciclic.imgix.net/logos/logo-clubebb-badge.png?auto=format,compress',
        creditas: 'https://ciclic.imgix.net/devices/creditas/logo-creditas-v.png?auto=format,compress',
        ebw: 'https://s3.amazonaws.com/ciclic-static.s3.amazonaws.com/logo/ebw--badge.webp',
        mederi: 'https://s3.amazonaws.com/ciclic-static.s3.amazonaws.com/logo/mederi--badge.webp',
        newvalue: 'https://ciclic.imgix.net/logos/logo_new_value_selo.png?auto=format,compress?auto=format,compress',
        passageirodeprimeira: 'https://s3.amazonaws.com/ciclic-static.s3.amazonaws.com/logo/passageirodeprimeira--badge.webp',
        privalia: 'https://ciclic.imgix.net/logos/privalia-badge.png?auto=format,compress',
        ybox: 'https://s3.amazonaws.com/ciclic-static.s3.amazonaws.com/logo/ciclic-mais--black--badge.svg'
      },
      hasPromocodeApplied: false
    }
  },
  mounted () {
    if (this.campaign) {
      this.isPartner = this.campaign in this.partnerLogos
    }
    if (this.promoCode.default || this.promoCode.code) {
      this.hasPromocodeApplied = true
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .infoPayment {
    &__title {
      font-family: $oscine-font-family;
    }

    &__container {
      margin-top: 32px;
    }

    &__listValues {
      &__label {
        margin-right: 20px;

        &--gray {
          color: #636D7A;

        }
      }

      &__value {
        min-width: 112px;
        text-align: right;
      }

      &__label,
      &__value {
        &--promo {
          color: #1A71B4;
        }
      }
    }

    &__amount {
      align-items: center;
      margin-top: 24px;
      padding-top: 24px;

      &--splitter {
        border-top: 1px solid rgba(#bdc2c6, 0.3);
      }
    }

    &__listValues li,
    &__amount,
    &__installments {
      display: flex;
      justify-content: space-between;
    }

    &__listValues li {
      &:not(:last-child) {
        margin-bottom: 8px
      }
    }

    &__amount {
      &__label,
      &__value {
        font-family: $oscine-font-family;
        font-size: 24px;
        line-height: 26px;
        font-weight: 700;
      }
    }

    &__voucher {
      color: #00CC67;
    }

    &__protectedBag {
      padding: 24px 0 0;
      margin-top: 24px;
      border-top: 1px solid rgba(#bdc2c6, 0.3);
    }

    &__installments {
      font-size: 16px;
    }

    &__amount + &__installments {
      margin-top: 16px;
    }

    div + * {
      margin-top: 32px;
    }

    .partner-discount{
      margin-top: 30px;
    }

    .partner-discount-label{
      border: solid 1px #00CC67;
      border-radius: 8px;
      padding: 12px 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 20px;
    }
    .partner-discount-label .partner-logo{
      width: 70px;
    }
    .partner-check-icon{
      width: 20px;
    }
  }
</style>
